export default __webpack_public_path__ + "assets/static/data/deck-schema.81eaee813f51b6877b490b1a0e1271da.json";